// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cE4fK","newExpiryDate":"styles_newExpiryDate__32fne","footer":"styles_footer__2UKL8"};